var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 3.33301V7.99967C2.66699 10.9452 5.05479 13.333 8.00033 13.333C10.9459 13.333 13.3337 10.9452 13.3337 7.99967V3.33301",
    stroke: "#3D484D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 3.33301H14.6663",
    stroke: "#3D484D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83398 10.3301V10.3359",
    stroke: "#3D484D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83398 8.33057C8.13285 8.32962 8.42275 8.22843 8.6573 8.04321C8.89185 7.85798 9.05748 7.59943 9.12769 7.30893C9.19789 7.01842 9.16862 6.71277 9.04454 6.44087C8.92046 6.16898 8.70876 5.94657 8.44332 5.80924C8.1781 5.67338 7.87472 5.63125 7.58252 5.68972C7.29033 5.74818 7.02651 5.90379 6.83398 6.13124",
    stroke: "#3D484D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraUnknown);
export default __webpack_public_path__ + "static/media/camera_unknown.8dc5b4841803956628ac10521f0a42cd.svg";
export { ForwardRef as ReactComponent };